module.exports = __webpack_public_path__ + "img/33_Mineiul_lunii_noiembrie_Ramnic_1778.355c9e79.jpg";